
export class Product
{
    static get Types()
    {
        return {
            PRODUCT: 'product',
            OFFER: 'offer'
        };
    }

    static get Fields()
    {
        return [
            'id',
            'parent_id',
            'name',
            'price',
            'base_price',
            'discount_price',
            'brand',
            'season',
            'color',
            'section_id',
            'section_name',
            'section_code',
            'discount_code',
        ]
    }

    constructor(element, values = [])
    {
        this.element = element;
        
        this.values = {};
        Product.Fields.forEach(key => {
            this.values[key] = {
                value: values[key] || null,
                wasSet: !BX.Type.isUndefined(values[key])
            };
        });

        Product.Fields.forEach(key =>  {
            Object.defineProperty(this, key, {
                get() {
                  return this.values[key].value;
                },
                set(val) {
                  throw new Error('Not supported');
                }
            });
        });
    }

    setField(key, value) {
        if (!Product.Fields.includes(key)) {
            return new Error('Not supported');
        }

        Object.assign(this.values[key], {
            value,
            wasSet: true
        });
    }

    setFields(values) {
        Product.Fields.forEach(key => {
            this.setField(key, values[key]);
        });
    }

    /**
     * @param {array} fields
     * @returns {Promise}
     */
    fill(fields = [])
    {
        if (!this.id) {
            return Promise.reject('ID isn\'s specified');
        }

        const needRequest = fields.find(key => this.values[key] && !this.values[key].wasSet);
        if (!needRequest) {
            return Promise.resolve(this); 
        }

        return new Promise((resolve, reject) => {
            $.post(`/ajax/product/analytics_data/${this.id}/`, {}, null, 'json')
                .then(({ value }) => {
                    this.setFields(value);
                    resolve(this);
                }).catch(reject);
        });
    }

    static createWithProductId(id)
    {
        return new Product(null, { id });
    }

    /**
     * @param {HTMLElement} element
     * @returns {Product}
     */
    static fromAttributes(element)
    {
        const data = {
            id: element.data('product') || element.data('id'),
            parent_id: element.data('product') || element.data('id'),
            name: element.data('name'), 
            price: element.data('price'),
            base_price: element.data('base-price'),
            discount_price: element.data('discount-price'),
            season: element.data('season'),
            brand: element.data('brand'),
            color: element.data('color'),
            section_id: element.data('section-id'),
            section_name: element.data('section-name') || element.data('section'),
            section_code: element.data('section-code'),
            discount_code: element.data('discount-code')
        };

        return new Product(element, data);
    }

    /**
     * 
     * @param {int} id 
     * @returns {Product}
     */
    static findById(id)
    {
        let element, product;
    
        // TODO: было бы хорошо, если бы был единный подход 
        if ($(`.js-ab-add_to_basket-item[data-product="${id}"]`).length) { // Список товаров
            element = $(`.js-ab-add_to_basket-item[data-product="${id}"]`).closest('.product__block');
            product = Product.fromAttributes(element);
            product.setField('id', parseInt(id, 10));
        } else if ($(`.js-product_offer-size[data-offer-id="${id}"]`).length) { // Карточка с тп
            element = $(`.js-product_offer-size[data-offer-id="${id}"]`).closest('.js-offer-switcher');
            product = Product.fromAttributes(element);
        } else if ($(`.js-ab-add_to_basket[data-id="${id}"]`).length) { // Карточка без тп
            element = $(`.js-ab-add_to_basket[data-id="${id}"]`).closest('.js-offer-switcher') 
            product = Product.fromAttributes(element)
        }

        return product && product.id ? product : new Product(null, { id });
    }
}
